<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-body">
        <div slot="body">
          <div class="intro-pw-wrap">
            <p class="intro-pw-tit">웨이브존<br />접속번호를 입력하세요.</p>
            <p class="intro-pw-text">(모르실 경우, 카운터에 문의하세요)</p>
            <ul class="intro-pw-input">
              <li>
                <div :class="'intro-pw' + getPinCodeCss(pinCode[0])"><input id="pin-code-0" @keyup="movePinCode(0)"
                  type="tel" v-model.number="pinCode[0]" title="웨이브온 접속번호 첫번째 자리" maxlength="1">
                </div>
              </li>
              <li>
                <div :class="'intro-pw' + getPinCodeCss(pinCode[1])"><input id="pin-code-1" @keyup="movePinCode(1)"
                  type="tel" v-model.number="pinCode[1]" title="웨이브온 접속번호 두번째 자리" maxlength="1">
                </div>
              </li>
              <li>
                <div :class="'intro-pw' + getPinCodeCss(pinCode[2])"><input id="pin-code-2" @keyup="movePinCode(2)"
                  type="tel" v-model.number="pinCode[2]" title="웨이브온 접속번호 세번째 자리" maxlength="1">
                </div>
              </li>
              <li>
                <div :class="'intro-pw' + getPinCodeCss(pinCode[3])"><input id="pin-code-3" @keyup="movePinCode(3)"
                  type="tel" v-model.number="pinCode[3]" title="웨이브온 접속번호 네번째 자리" maxlength="1">
                </div>
              </li>
            </ul>
            <ul class="intro-pw-btn">
              <li><button @click="setPinCodePage(false)" class="btn-cancel">취소</button></li>
              <li><button @click="isPinCodeLogin()" class="btn-confirm">확인</button></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/components/eventbus/EventBus'
import utils from '@/common/util/utils'
import { MSG_POOQZONE_PINCODE_EMPTY } from '@/common/constant'
export default {
  data () {
    return {
      pinCode: ['', '', '', '']
    }
  },
  methods: {
    // 핀코드 입력에 따른 CSS
    getPinCodeCss (target) {
      return target.toString() ? ' intro-exist' : ''
    },
    // 핀코드 확인 여부
    isPinCodeLogin () {
      let pinCode = this.pinCode.join('')
      // console.log(pinCode, pinCode.length);
      if (pinCode && pinCode.length === 4) {
        EventBus.$emit('clickPinCodeLogin', pinCode)
      } else {
        utils.alert(MSG_POOQZONE_PINCODE_EMPTY)
      }
    },
    movePinCode (id) {
      let current = document.getElementById('pin-code-' + id)
      let next = document.getElementById('pin-code-' + (id + 1))
      if (current && next && this.pinCode[id].toString()) {
        next.focus()
      }
    },
    setPinCodePage (isView) {
      EventBus.$emit('setPinCodePage', isView)
    }
  }
}
</script>
<style scoped>
  .intro-pooqzone > img{
    width: 132px;
  }
  .pooqtv-logo01 > img{
    width: 64px;
  }
  .pooq-tv-logo02 > img{
    width: 64px;
  }
  .intro-slider .swiper-slide{
    width: 220px !important;
  }
  .intro-slider .swiper-slide > img{
    width: 220px;
    height: 390px;
  }
  .intro-slider .swiper-pagination-bullets{
    bottom: 0 !important;
  }
  .intro-slider .swiper-pagination-bullet{
    background-color: #fff;
    margin: 0 3px !important;
    width: 7px;
    height: 7px;
  }
  .intro-slider .swiper-pagination-bullet-active{
    background-color: transparent;
    border: 1px solid #fff;
  }
  .intro-sec02-bt > img{
    width: 132px;
  }

  /*웨이브온 로그인 팝업*/
  .modal-mask{
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-wrapper{
    display: table-cell;
    vertical-align: middle;
  }
  .modal-default-button{
    position: fixed;
    right: 30px;
    top: 30px;
  }
  .intro-pw-wrap{
    width: 295px;
    margin: 0 auto;
    padding: 40px 20px;
    height: 370px;
    border: 1px #1b1b1b solid;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #1b1b1b;
  }
  .intro-pw-tit{
    font-size: 20px;
    line-height: 29px;
    color: #fff;
  }
  .intro-pw-text{
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .intro-pw-input{
    width: 212px;
    margin: 50px auto 0;
  }
  .intro-pw-input:after{
    content: "";
    display: block;
    clear: both;
  }
  .intro-pw-input li{
    float: left;
    width: 38px;
    text-align: center;
    height: 48px;
  }
  .intro-pw-input li + li{
    margin-left: 20px;
  }
  .intro-pw:before{
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    margin: -10px auto 5px;
    border-radius: 50%;
    background-color: #2f2f2f;
  }
  .intro-pw.intro-exist:before{
    background-color: #fff;
  }
  .intro-pw{
    border-bottom: 1px solid #2f2f2f;
  }
  .intro-pw.intro-exist{
    border-bottom-color: #fff;
  }
  .intro-pw-input input[type="tel"]{
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    background: transparent;
    text-align: center;
    font-size: 26px;
    color: #fff;
    line-height: 46px;
    font-weight: 400;
    width: 100%;
  }
  .intro-pw-input input[type="tel"]:focus{
    border: 0 none;
  }
  .intro-pw-btn{
    text-align: center;
    margin-top: 65px;
  }
  .intro-pw-btn li{
    display: inline-block;
    margin: 0 4px;
  }
  .intro-pw-btn li button,
  .intro-pw-btn li input[type="submit"]{
    width: 91px;
    height: 34px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }
  .intro-pw-btn .btn-cancel{
    border: 1px #252525 solid;
    background-color: #252525;
  }
  .intro-pw-btn .btn-confirm{
    border: 1px #1351f9 solid;
    background-color: #1351f9;
  }
</style>
